import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from "styled-components";
import { createStyleComponent } from "@hzero-front-ui/core";
var getAutoCompleteStyle = function getAutoCompleteStyle() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .c7n-pro-auto-complete-wrapper {\n      &.c7n-pro-auto-complete-disabled .c7n-pro-auto-complete,\n      &.c7n-pro-auto-complete-disabled label:hover .c7n-pro-auto-complete,\n      &.c7n-pro-auto-complete:disabled {\n        background: initial;\n      }\n    }\n  "])));
};
export default createStyleComponent("autoComplete", getAutoCompleteStyle);